<template>
  <div
    :class="`keyframe-animation-${animationName}`"
    :style="stylesAnimation"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Keyframe',
  props: {
    animation: {
      type: String,
      required: true,
    },
    animationName: {
      type: String,
      required: true,
    },
    start: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      playStart: false,
    };
  },
  computed: {
    stylesAnimation() {
      return {
        animationName: this.playStart ? this.animationName : 'none',
      };
    },
  },
  mounted() {
    if (typeof document !== 'undefined' && document.styleSheets[0]) {
      const styleSheet = document.styleSheets[0];
      const appliedAnimation = `@keyframes ${this.animationName} ${this.animation}`;

      styleSheet.insertRule(appliedAnimation, styleSheet.cssRules.length);
    }

    this.$el.addEventListener('animationend', (e) => {
      this.$emit('onAnimationEnd', e);
    });
  },
  watch: {
    start: {
      immediate: true,
      handler: function (value) {
        if (value) {
          this.playStart = value;
        }
      },
    },
  },
};
</script>
